<template>
  <div class="books">
    <h3 class="books_head">已阅书籍</h3>
    <ul class="havaread_list">
      <li class="haveread_li" v-for="(item,index) of booksArr" v-bind:key="index">
        <img src="../../assets/picture/book.png" class="readli_img" @click="gobook(item)" />
        <p class="readli_read">
           <span
              :style="'background: linear-gradient(to top, #DF1829 ' + item.proportion + '%,#fff 0%)'"
            ></span>
            已阅{{item.proportion}}%

        </p>
        <p class="readli_name">{{item.book_name}}</p>
        <div class="readli_tip">
          <p @click="gomarks(item)" class="readli_mark" v-if="item.be_marked">书签</p>
          <P @click="gotags(item)" class="readli_notes" v-if="item.be_tagged">标注</P>
        </div>
      </li>
    </ul>
    <div class="pagination" v-if="total_pages>1">
      <el-pagination
        @prev-click="handlePre"
        @next-click="handleNext"
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :page-size="1"
        :current-page="current_page"
        :total="total_pages"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {addstamp} from '../../util/stamp';
export default {
  data() {
    return {
      userid: null,
      booksArr: [],
      total_pages: 1,
      current_page:1,
      page_size:12
    };
  },
  created() {
    this.userid = parseInt(this.$store.state.user_id);
    // this.userid = 1;
    // console.log(this.userid)
    this.loadingbooks();
    const hashLocation = this.$route.path
            //   const newLocation = hashLocation.split("#/")[1];
            const url = "https://www.kanguji.com"+hashLocation
            this.$matomo.setCustomUrl(url);//覆盖页面报告的url，可以自定义页面url，加上本页面路由
            //   this.$matomo.trackEvent(shopCode,hashLocation);//事件
            // this.$matomo.trackPageView(hashLocation);//页面名称,可以自定义页面名称
  },
  methods: {
    loadingbooks() {
      var that = this;
      var params = {
        user_id: that.userid,
        page: that.current_page,
				page_size : that.page_size,
      };
      var sign = addstamp(params)
      delete params.token
      params['sign'] = sign
      this.$axios
        .get("books/read", {
          params
        })
        .then(function(res) {
            that.current_page = res.data.data.current_page
            that.booksArr = res.data.data.volumes;
            that.total_pages = res.data.data.total_pages
          
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    handlePre(){
					this.current_page=val
					this.loadingbooks()
    },
    handleNext(val){
					this.current_page=val
					this.loadingbooks()
      },
      changePage(val){
					this.current_page=val
					this.loadingbooks()
			},
    gomarks(item) {
      this.$router.push({
        path: "bookMarks",
        query: {
          volume_id: item.volume_id
        }
      });
    },
    gotags(item) {
      this.$router.push({
        path: "bookTags",
        query: {
          volume_id: item.volume_id
        }
      });
    },
    gobook(item) {
      let pictureUrl = this.$router.resolve({
        path: "/picture",
        query: {
          volume_id: item.volume_id
        }
      });
      window.open(pictureUrl.href, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped type="text/css">
.books {
  width: calc(100% - 2px);
  height: 100%;
  box-sizing: border-box;
  //   border: 1px solid red;
  background: #fff;
  padding-bottom: 80px;
  border: 1px solid transparent;
  .books_head {
    width: 1200px;
    font-size: 24px;
    margin: 0 auto;
    margin-top: 60px;
    // border: 1px solid red;
  }
  .havaread_list {
    width: 1200px;
    margin: 0 auto;
    // border: 1px solid red;
    // display: flex;
    margin-bottom: 30px;
    // flex-wrap: wrap;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    .haveread_li {
      width: 25%;
      // vertical-align: top;
      //   border: 1px solid orange;
      .readli_img {
        cursor: pointer;
        width: 110px;
        height: 138px;
        display: block;
        margin: 0 auto;
        margin-top: 40px;
      }
      .readli_read {
        color: #cd3333;
        font-size: 14px;
        margin-top: 14px;
        height: 14px;
        line-height: 14px;
        span {
          width: 8px;
          height: 10px;
          border: 1px solid #df1829;
          display: inline-block;
          position: relative;
          vertical-align: bottom;
          // background: #DF1829;
          // background: linear-gradient(to top, #DF1829 100%,#fff 0%);
          &::after {
            content: "";
            width: 6px;
            height: 2px;
            display: block;
            position: absolute;
            top: -4px;
            left: 1px;
            background: #df1829;
          }
        }

      }
      .readli_name {
        font-size: 14px;
        margin-top: 25px;
        color: #333;
        margin-bottom: 10px;
      }
      .readli_tip {
        display: flex;
        justify-content: space-between;
        width: 186px;
        margin: 0 auto;
        p {
          line-height: 29px;
          border-radius: 6px;
          font-size: 14px;
          margin: 0 auto;
          &:hover {
            cursor: pointer;
          }
        }
        .readli_mark {
          width: 82px;
          height: 29px;
          color: #e6522b;
          border: 1px solid #bfbfbf;
        }
        .readli_notes {
          width: 84px;
          height: 31px;
          color: #fffefe;
          background: linear-gradient(left, #ff7c5a, #e6522b);
        }
      }
    }
  }
}
// .pagination{
//   width: 100%;
//   border: 1px solid red;
//   margin: 0 auto;
// }
</style>
<style>
/* // 分页 */
.books .pagination {
  margin: 10px auto 50px;
  width: 100%;
  text-align: center;
  /* margin-bottom: 100px; */
}
.books .pagination .el-pagination.is-background .btn-next,
.books .pagination .el-pagination.is-background .btn-prev {
  background: #e6522b !important;
  color: #fff;
  min-width: 50px;
  height: 36px !important;
  line-height: 34px;
  border-radius: 4px;
  margin: 0 20px;
}
.books .pagination .el-icon {
  font-size: 14px;
  color: #fff;
}
.books .pagination .el-icon:disabled {
  background: #fff;
}
.books .pagination .el-icon:disabled .el-icon {
  color: #bfbfbf;
  border: 1px solid #ddd;
  min-width: 50px;
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
}
/* // 中间页码 */
.books .pagination .el-pager li {
  min-width: 38px !important;
  height: 38px !important;
  line-height: 38px !important;
  border-radius: 19px !important;
  font-size: 16px;
  border: 1px solid #ddd;
  color: #999;
  background-color: #fff !important;
  margin: 0 11px !important;
}
.books .pagination .el-pager li:hover {
  background: #e6522b !important;
  color: #fff !important;
  border: 1px transparent;
  line-height: 34px;
}
.books .pagination .el-pager li.active {
  background: #e6522b !important;
  color: #fff !important;
  line-height: 34px;
  border: 1px transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/page/books.vue